import { Box, Typography } from "@mui/material"
import useTranslation from "../../../hooks/use_translation"

const Specialists = (props) => {
  const { data } = props

  if (!data.length) return

  const { anamnesis } = useTranslation()

  return (
    <>
      <Typography variant="h6" sx={{ fontWeight: 700 }}>
        {anamnesis?.disease_card_specialists}
      </Typography>

      <Box component="ol" sx={{ ml: -2, mt: 0.5 }}>
        {data.map((item, i) => (
          <Typography key={i} component="li">
            {item.name}
          </Typography>
        ))}
      </Box>
    </>
  )
}

export default Specialists
